<script>
  import AccordionItem from "./AccordionItem.svelte";
  import RichText from "./RichText.svelte";

  export let items = [];
</script>

<div class="w-full embedded-content">
  {#each items as item}
    <!-- TODO: remove `isOpen` if stories refactored using interactions -->
    <AccordionItem label={item.fields.headline} isOpen={item.fields.isOpen}>
      <RichText node={item.fields.body} />
    </AccordionItem>
  {/each}
</div>
